module.exports = __webpack_public_path__ + "img/banner.0ea196b1.png";